// import 'semantic-ui-less/semantic.less';
import '../../semantic-ui/semantic-ui.css';